<template>
  <div class="personalized_samples__wrap">
    <Breadcrumb :config="breadcrumb" />
    <ImageTextAnimate :config="config" />
  </div>
</template>

<script>
import Breadcrumb from "@/components/Breadcrumb";
import ImageTextAnimate from '@/components/ImageTextAnimate';
import PersonalizedSampleImage from '@/assets/imgs/PersonalizedSample.jpg';

export default {
  name: "PersonalizedSample",
  components: { Breadcrumb, ImageTextAnimate },
  data() {
    return {
      breadcrumb: {
        items: [{ text: "个性化小样", href: "" }]
      },
      config: {
        title: "初试体验",
        subtitle: "探索希思黎",
        desc: `为了让您体验更多我们的明星产品，下单时，你可以在购物车页面选择产品体验装。

          在Sisley法国希思黎中国官网及小程序官方商城购买任意商品，您可以在购物车页面选择体验装，所选体验装将与您的订单一起发货。`,
        src: PersonalizedSampleImage
      }
    };
  }
}
</script>

<style lang="scss" scoped>
  @media screen and (min-width: 64em) {
    .gift_customization___wrap /deep/ .breadcrumb { padding: 0 1.875rem; }
  }
</style>